import { useEffect, useState } from "react";
import {
  IconButton,
  Modal as MuiModal,
  Box,
  Tabs,
  Tab
} from "@mui/material";
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";

import useStyles from "../styles";
import nosearch from "../../../assets/images/no-search.svg";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import NotFounditem from "../../error/NotFound";
import PageLoader from "../../../components/PageLoader";
import { httprequest } from "../../../data/api";
import { useUserState } from "../../../context/UserContext";
import Table from "../../../components/Table/Table";
import { TableSearch } from "../../../components/Table/TableActions";
import useWindowSize from "../../../hooks/useWindow";

const TERM_ENDPOINT = "/api/v1/school-plan/terms";

const GET_SESSIONS = "/api/v1/school-plan/session";
const GET_CLASS_GRADES = "/api/v1/broad-sheet/";
const CLASSES_ENDPOINT = "/api/v1/class";
const OBTAINABLE_SCORE = "/api/v1/obtainable-score";
const TEACHERS_CLASS_ENDPOINT = "/api/v1/teacher/classes";

const TermBroadsheet = () => {
  const classes = useStyles();
  const [selectedClass, setSelectedClass] = useState(null);
  const [classesData, setClassData] = useState([]);
  const [activeSession, setActiveSession] = useState([]);
  const [selectedSessionTerms, setSelectedSessionTerms] = useState([]);
  const [allSessions, setAllSessions] = useState([]);
  const [obtainablescore, setObtainableScore] = useState([]);
  const [aselectedTerm, setASelectedTerm] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [classGrades, setClassGrades] = useState([]);
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [isPageFetching, setIsPageFetching] = useState(false);
  const { userRole } = useUserState();
  const isTeacher = userRole?.role_type === "employee";
  const [teacherClassData, setTeacherClassData] = useState([]);
  const [studentDetailsModal, setStudentDetailsModal] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [showClassList, setShowClassList] = useState(true);
  const [searchResult, setSearchResult] = useState([]);
  // NEW STATE VARIABLES
  const [selectedSubjectIndex, setSelectedSubjectIndex] = useState(0);
  const [classSubjects, setClassSubjects] = useState([]);

  const width = useWindowSize();
  const mobile = width < 600;

  // Handle close Student Details Modal
  const handleCloseStudentDetailsModal = () => {
    setStudentDetailsModal(false);
    setSelectedStudent(null);
  };

  // Open student details modal
  const handleViewStudentDetails = (student) => {
    setSelectedStudent(student);
    setStudentDetailsModal(true);
  };

  // Search function for students
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);

    if (!value.trim()) {
      if (filteredStudents.length > 0) {
        const currentSubject = filteredStudents[selectedSubjectIndex];
        setFilteredStudents(prev => {
          const updated = [...prev];
          updated[selectedSubjectIndex] = {
            ...currentSubject,
            students: classGrades?.sheet?.[selectedSubjectIndex]?.students || []
          };

          return updated;
        });
      }

      return;
    }

    if (filteredStudents.length > 0) {
      const currentSubject = filteredStudents[selectedSubjectIndex];
      const originalStudents = classGrades?.sheet?.[selectedSubjectIndex]?.students || [];

      const filtered = originalStudents.filter(student => `${student?.last_name} ${student?.first_name}`.toLowerCase().includes(value)
      );

      setFilteredStudents(prev => {
        const updated = [...prev];
        updated[selectedSubjectIndex] = {
          ...currentSubject,
          students: filtered
        };

        return updated;
      });
    }
  };

  // Handle class selection
  const handleClassSelect = (classItem) => {
    setSelectedClass(classItem);
    setShowClassList(false);
  };

  const columns = [
    {
      name: "Class",
      selector: (row) => (
        <>
          {row?.class_name || row?.name || "--/--"}
        </>
      )
    },
    {
      name: "No of Student",
      selector: (row) => (
        <>
          {row?.no_of_students || "--/--"}
        </>
      )
    },
    {
      name: "",
      center: "true",
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <button className="table-action-icon" onClick={() => handleClassSelect(row)}>
            <Icon icon="mingcute:right-line" />
          </button>
        </div>
      )
    }
  ];

  // Filter Notice table
  const handleSearchNotice = (e) => {
    const { value } = e.target;
    const valArray = value.split(" ");
    const result = isTeacher ? teacherClassData : classesData?.filter((data) => valArray?.every(
      (word) => data?.class_name?.toLowerCase().includes(word.toLowerCase()) ||
            data?.name?.toLowerCase().includes(word.toLowerCase()) ||
            data?.priority?.toLowerCase().includes(word.toLowerCase())
    ));
    setSearchResult(result);
  };

  // Handle back to class list
  const handleBackToClasses = () => {
    setShowClassList(true);
    setSelectedClass(null);
    setFilteredStudents([]);
    setClassGrades([]);
    setSearchTerm("");
    setSelectedSubjectIndex(0);
    setClassSubjects([]);
  };

  // Handle subject tab change
  const handleSubjectChange = (event, newValue) => {
    setSelectedSubjectIndex(newValue);
    // Reset search term when changing subjects
    setSearchTerm("");

    // Restore original students for the selected subject
    if (classGrades?.sheet?.[newValue]) {
      const updatedSubjects = [...filteredStudents];
      updatedSubjects[newValue] = {
        ...classGrades?.sheet?.[newValue],
        students: classGrades?.sheet?.[newValue]?.students || []
      };
      setFilteredStudents(updatedSubjects);
    }
  };

  // Get all classes
  const getAllClasses = () => {
    setIsPageFetching(true);
    httprequest
      .get(isTeacher ? TEACHERS_CLASS_ENDPOINT : CLASSES_ENDPOINT)
      .then((res) => {
        const teacherClass = res?.data?.data?.map(item => item.class) || [];
        const physicalClasses = res?.data?.data?.filter(
          (data) => data?.class_type === "physical"
        );
        setIsPageFetching(false);
        setClassData(physicalClasses);
        setTeacherClassData(teacherClass);
        setSearchResult(isTeacher ? teacherClass : physicalClasses);
      })
      .catch((err) => {
        toast.error(err?.response?.data);
      });
  };

  // Get all terms for a session
  const getAllTerms = (Session_ID) => {
    httprequest
      .get(TERM_ENDPOINT)
      .then((res) => {
        setSelectedSessionTerms(res?.data?.data.filter((selected_term) => selected_term?.session_id === Session_ID));
      });
  };

  // Get all sessions
  const getAllSessions = async () => {
    try {
      const res = await httprequest.get(GET_SESSIONS);
      setAllSessions(res?.data?.data);
      setActiveSession(res?.data?.data?.find((active_session) => active_session?.current_session === true));
    } catch (err) {
      toast.error(err?.response?.message);
    }
  };

  const active_term_session = activeSession?.terms?.find((found_active_term) => found_active_term?.is_current === true);

  // Get all obtainable scores
  const getAllObtainableScores = () => {
    httprequest
      .get(OBTAINABLE_SCORE)
      .then((res) => {
        setObtainableScore(res?.data?.data?.filter((scores) => scores?.session?.id === active_term_session?.session_id));
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };

  // Handle session change
  const handleSessionChange = (e) => {
    const Session_ID = e.target.value;
    getAllTerms(Session_ID);
  };

  // Get all class results
  const handleGetAllClassResult = async (classID, termId) => {
    setIsPageFetching(true);
    try {
      const res = await httprequest.get(`${GET_CLASS_GRADES}${classID}?term_id=${termId}`);
      setIsPageFetching(false);
      setClassGrades(res?.data?.data);

      // Set up subjects data for tabs
      const subjects = res?.data?.data?.sheet || [];
      setClassSubjects(subjects);
      setFilteredStudents(subjects);

      // Reset to first subject
      setSelectedSubjectIndex(0);
      setSearchTerm("");
    } catch (err) {
      setIsPageFetching(false);
      toast.error(err?.response?.message || "Failed to fetch results");
    }
  };

  // Handle term change
  const handleTermChange = (event) => {
    const selectedTermId = event.target.value;
    setASelectedTerm(selectedTermId);
  };

  // Fetch results when class and term are selected
  useEffect(() => {
    if (selectedClass && aselectedTerm) {
      const classId = selectedClass?.id || selectedClass?.class_id;
      handleGetAllClassResult(classId, aselectedTerm);
    }
  }, [selectedClass, aselectedTerm]);

  // Effects
  useEffect(() => {
    getAllSessions();
    getAllClasses();
  }, []);

  useEffect(() => {
    if (active_term_session?.id) {
      setASelectedTerm(active_term_session?.id);
      getAllObtainableScores();
    }
  }, [active_term_session]);

  useEffect(() => {
    if (activeSession?.id) {
      getAllTerms(activeSession?.id);
    }
  }, [activeSession]);

  useEffect(() => {
    if (selectedSessionTerms?.length > 0) {
      const currentTerm = selectedSessionTerms.find((t) => t?.is_current === true) || selectedSessionTerms[0];
      if (currentTerm?.id) {
        setASelectedTerm(currentTerm.id);
      }
    }
  }, [selectedSessionTerms]);

  // Get current subject data
  const currentSubject = filteredStudents[selectedSubjectIndex] || {};
  const currentSubjectName = currentSubject?.subject?.name || "No Subject";
  const currentSubjectStudents = currentSubject?.students || [];

  // Prepare columns for subject table
  const subjectColumns = [
    {
      name: "Student Name",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Student Name</p>}
          {`${row?.last_name} ${row?.first_name}`}
        </>
      )
    },
    ...(obtainablescore?.[0]?.ca?.map(ca => ({
      name: ca.ca_type,
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">{ca.ca_type}</p>}
          {row?.scores?.CA_scores?.[ca?.ca_type] || "--/--"}
        </>
      )
    })) || []),
    {
      name: "Total CA",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Total CA</p>}
          {row?.scores?.CA_total || "--/--"}
        </>
      )
    },
    {
      name: "Exam",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Exam</p>}
          {row?.scores?.exam_score || "--/--"}
        </>
      )
    },
    {
      name: "Total",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Total</p>}
          {row?.scores?.total || "--/--"}
        </>
      )
    },
    {
      name: "Grade",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Grade</p>}
          {row?.scores?.grade || "--/--"}
        </>
      )
    },
    {
      name: "",
      cell: (row) => (
        <IconButton
          onClick={() => handleViewStudentDetails(row)}
          className={classes.actionBtn}
        >
          <Icon icon="mingcute:right-line" width="20" height="20" />
        </IconButton>
      ),
      center: true
    }
  ];

  // Prepare columns for student details modal
  const studentDetailsColumns = [
    {
      name: "Subject",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Subject</p>}
          {row?.subject?.name || "--/--"}
        </>
      )
    },
    ...(obtainablescore?.[0]?.ca?.map(ca => ({
      name: ca?.ca_type,
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">{ca?.ca_type}</p>}
          {row?.scores?.CA_scores?.[ca?.ca_type] || "--/--"}
        </>
      )
    })) || []),
    {
      name: "Total CA",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Total CA</p>}
          {row?.scores?.CA_total || "--/--"}
        </>
      )
    },
    {
      name: "Exam",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Exam</p>}
          {row?.scores?.exam_score || "--/--"}
        </>
      )
    },
    {
      name: "Total",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Total</p>}
          {row?.scores?.total || "--/--"}
        </>
      )
    },
    {
      name: "Grade",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Grade</p>}
          {row?.scores?.grade || "--/--"}
        </>
      )
    }
  ];

  // student details modal data
  const studentDetailsData = selectedStudent ?
    classSubjects
      ?.map(subject => ({
        subject: subject.subject,
        scores: subject?.students?.find(s => s.id === selectedStudent?.id)?.scores || {}
      }))
      ?.filter(item => Object.keys(item.scores)?.length > 0) : [];

  return (
    <div className={"page-content"}>
      <div className={classes.acontainer}>
        {/* Session and Term Selection */}
        <div className={classes.selectionContainer}>
          <div className={classes.filters}>
            {activeSession?.id && (
              <SelectGroup
                label="Session"
                children={
                  <select
                    defaultValue={activeSession?.id}
                    onChange={handleSessionChange}
                    name="session"
                  >
                    <option value="">---Select Session---</option>
                    {allSessions?.map((sesh) => (
                      <option key={sesh?.id} value={sesh?.id}>
                        {sesh?.session}
                      </option>
                    ))}
                  </select>
                }
              />
            )}

            {selectedSessionTerms?.length > 0 && (
              <SelectGroup
                label="Term"
                children={
                  <select onChange={handleTermChange} name="term" value={aselectedTerm}>
                    <option value="">---Select Term---</option>
                    {selectedSessionTerms?.map((data) => (
                      <option key={data?.id} value={data?.id}>
                        {data?.term}
                      </option>
                    ))}
                  </select>
                }
              />
            )}
          </div>

          {/* Main Content Area */}
          <div className={classes.mainContent}>
            {/* Class Selection View */}
            {showClassList && (
              <div className={classes.classListView}>
                <div className={classes.classesContainer}>
                  {(isTeacher ? teacherClassData?.length > 0 : classesData?.length > 0) ? (
                    <div>
                      <Table
                        data={searchResult}
                        columns={columns}
                        subHeader={true}
                        pagination
                        subHeaderComponent={
                          <TableSearch
                            placeholder="Search by title..."
                            searchTableFunc={handleSearchNotice}
                          />
                        }
                      />
                    </div>
                  ) : (
                    <div className={classes.noClasses}>
                      <NotFounditem
                        img={nosearch}
                        title="No Classes Found"
                        subtitle="No classes have been assigned to you yet."
                      />
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Table View - Slides in when class is selected */}
            {!showClassList && selectedClass && (
              <div className={`${classes.tableView} ${classes.tableViewActive}`}>
                <div className={classes.tableHeader}>
                  <div className={classes.tableHeaderLeft}>
                    <div
                      className={classes.backButton}
                      onClick={handleBackToClasses}
                    >
                      <Icon icon="mdi:arrow-left" width="20" height="20" />
                      Back to Classes
                    </div>
                    <h3 className={classes.tableTitle}>
                      {isTeacher ? selectedClass?.name : selectedClass?.class_name}
                    </h3>
                  </div>
                </div>

                {/* Subject Tabs */}
                {classSubjects.length > 0 && (
                  <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
                    <Tabs
                      value={selectedSubjectIndex}
                      onChange={handleSubjectChange}
                      variant="scrollable"
                      scrollButtons="auto"
                      aria-label="subject tabs"
                    >
                      {classSubjects.map((subject, index) => (
                        <Tab
                          key={subject?.subject?.id || index}
                          label={subject?.subject?.name || `Subject ${index + 1}`}
                          sx={{ textTransform: "none" }}
                        />
                      ))}
                    </Tabs>
                  </Box>
                )}

                {/* Subject Name Display */}
                <div className={classes.subjectclicked}>
                  <h4 className={classes.subjectTitle}>
                    {currentSubjectName}
                  </h4>
                </div>

                {isPageFetching ? (
                  <div className={classes.tableLoader}>
                    <PageLoader />
                  </div>
                ) : currentSubjectStudents?.length === 0 ? (
                  <div className={classes.tableEmpty}>
                    <NotFounditem
                      img={nosearch}
                      title="No Results Found"
                      subtitle={`No results have been recorded for ${currentSubjectName} in this term.`}
                    />
                  </div>
                ) : (
                  <div className={classes.tableContent}>
                    <Table
                      data={currentSubjectStudents}
                      columns={subjectColumns}
                      pagination
                      subHeaderComponent={
                        <TableSearch
                          placeholder="Search students..."
                          searchTableFunc={handleSearch}
                          value={searchTerm}
                        />
                      }
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {/* Student Details Modal */}
        <MuiModal
          open={studentDetailsModal}
          onClose={handleCloseStudentDetailsModal}
          className={classes.studentModal}
        >
          <div className={classes.studentModalContent}>
            <div className={classes.studentModalHeader}>
              <h3 className={classes.studentModalTitle}>
                {selectedStudent ? `${selectedStudent?.last_name} ${selectedStudent?.first_name}` : ""} - All Subjects Results
              </h3>
              <IconButton
                onClick={handleCloseStudentDetailsModal}
                className={classes.closeButton}
              >
                <Icon icon="mdi:close" width="24" height="24" />
              </IconButton>
            </div>

            <div className={classes.studentModalBody}>
              {studentDetailsData.length > 0 ? (
                <Table
                  data={studentDetailsData}
                  columns={studentDetailsColumns}
                  pagination
                />
              ) : (
                <div className={classes.noData}>
                  No subject results found for this student
                </div>
              )}
            </div>
          </div>
        </MuiModal>
      </div>
    </div>
  );
};

export default TermBroadsheet;
